import { apiFetch } from './apiFetch';
import type { BoxSettings } from '@salaries/shared';

export async function getBoxSettings(): Promise<BoxSettings> {
  return apiFetch<BoxSettings>('/box-settings');
}

export async function updateBoxSettings(settings: BoxSettings): Promise<BoxSettings> {
  return apiFetch<BoxSettings>('/box-settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  });
}
